export const env = (variableName) => {
    if (window && window['_env_'] && window['_env_'][variableName]) {
        return window['_env_'][variableName];
    }
    return process.env[variableName];
};
//# sourceMappingURL=env.js.map